import {useSvip} from '../../hooks/useSvip';
import { ArmoryFeedback, useArmoryAttempt } from './ArmoryFeedback';
import { DisplayGrid } from '../../components/Grid/DisplayGrid';
import { JButton } from '../../components/UI/JButton';
import JPanel from '../../components/UI/JPanel';
import { MultilineLabel } from '../../components/UI/MultilineLabel';
import { useAppSelector } from '../../hooks';
import { ItemLocation, ItemType } from '../../enums';
import { DropZone } from '../../components/DropZone/DropZone';
import { Item } from '../../components/Item';
import { toServer } from '../../util/ServerSocket';
import { getItemType } from '../../resources/Items';

const REFINE_TYPES = [
  ItemType.Weapon,
  ItemType.Belt,
  ItemType.Body,
  ItemType.Gloves,
  ItemType.Helm,
  ItemType.Shoes,
  ItemType.Amulet,
  ItemType.Ring,
];
const TALISMAN_IDS = [161004];

export function Refine() {

  const item = useAppSelector((state) => state.inventory.items[state.inventory.locations[ItemLocation.Refine]]);
  const talisman = useAppSelector((state) => state.inventory.items[state.inventory.locations[ItemLocation.RefineTalisman]]);
  const dragging = useAppSelector((state) => state.ui.dragging.item);
  const svip=useSvip();
  const coupons=useAppSelector(s=>s.character.currency.giftCertificates);
  const hasTalisman=!!talisman&&TALISMAN_IDS.includes(talisman.iid)&&talisman.core[1]>=1;
  const attempt = useArmoryAttempt('refineGetInfo', 'refineAttempt', item, talisman, hasTalisman?'ยันต์รีไฟน์ 1 ชิ้น':'50 คูปองแทนยันต์ (SVIP)',svip);

  function onDrop(uid: string) {
    toServer('refineSetItem', { uid, location: ItemLocation.Refine });
  }

  function onDropTalisman(uid: string) {
    toServer('refineSetItem', { uid, location: ItemLocation.RefineTalisman });
  }

  return (
    <>
      <JPanel size={{ width: 373, height: 180 - 26 }} background="UIResource.Common.BigBG1">
        <JPanel
          className="single-container"
          size={{ width: 73, height: 115 }}
          position={{ x: 25, y: 10 }}
          background="UIResource.Common.BigBG3">
          <MultilineLabel size={{ width: 73, height: 20 }} position={{ x: 0, y: 2 }} text="Equipment" style={{ textAlign: 'center' }} />
          <DisplayGrid size={{ width: 2, height: 3 }} position={{ x: 5, y: 20 }}>
            {item === undefined && dragging !== null && REFINE_TYPES.includes(getItemType(dragging)) && (
              <DropZone onDrop={onDrop} location={ItemLocation.Refine} />
            )}
            {item && <Item item={item} />}
          </DisplayGrid>
        </JPanel>

        <JPanel size={{ width: 23, height: 23 }} position={{ x: 165, y: 62 }} background="UIResource.Compose.Add" />

        <MultilineLabel
          size={{ width: 132, height: 20 }}
          position={{ x: 217, y: 30 }}
          text="Refining Talisman"
          style={{ textAlign: 'center' }}
        />

        <JPanel
          className="single-container"
          size={{ width: 46, height: 46 }}
          position={{ x: 260, y: 50 }}
          background="UIResource.Common.BigBG3">
          <DisplayGrid size={{ width: 1, height: 1 }} position={{ x: 5, y: 5 }}>
            {talisman === undefined && dragging !== null && TALISMAN_IDS.includes(dragging.iid) && (
              <DropZone onDrop={onDropTalisman} location={ItemLocation.RefineTalisman} />
            )}
            {talisman && <Item item={talisman} />}
          </DisplayGrid>
        </JPanel>

        <MultilineLabel
          size={{ width: 160, height: 37 }}
          position={{ x: 204, y: 100 }}
          text={svip?'ใช้ 2,500 หิน + ยันต์ 1 ชิ้น หากไม่มียันต์ ใช้ 50 คูปองแทน':'ใช้ 2,500 หิน + ยันต์รีไฟน์ 1 ชิ้นต่อครั้ง'}
          style={{ textAlign: 'center' }}
        />
        <ArmoryFeedback cost={attempt.info.cost} rate={attempt.info.rate} result={attempt.result} />
      </JPanel>

      <JButton
        size={{ width: 100, height: 22 }}
        position={{ x: 40, y: 185 - 26 }}
        text="Attempt"
        disabled={attempt.disabled || (!hasTalisman&&(!svip||coupons<50)) || (!!attempt.info.couponCost&&coupons<attempt.info.couponCost)}
        loading={attempt.loading}
        onClick={attempt.onAttempt}
      />
      <JButton size={{ width: 100, height: 22 }} position={{ x: 235, y: 185 - 26 }} text="Instructions" disabled />
    </>
  );
}
